export default {
  country (state, getters, rootState) {
    return state.countryCode ? state.countryCode.toLowerCase() : 'gb'
  }
}



// WEBPACK FOOTER //
// ./src/modules/geolocation/store/getters.js